'use client';

import { useEffect } from 'react';
import  './SearchTabs.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCar, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Search from '@/components/Search/Search';
import ServiceBookingForm from '@/components/forms/ServiceBookingForm/ServiceBookingForm';

interface SearchTabsProps {
    search: boolean;
    sell: boolean;
    service: boolean;
  }

export default function SearchTabs({ search, sell, service }: SearchTabsProps) {

    // Match height of tallest tab content
    useEffect(() => {
        const tabContent = document.querySelector('.tab-content') as HTMLElement | null;
        const tabPanes = document.querySelectorAll('.tab-pane') as NodeListOf<HTMLElement>;
    
        if (tabContent && tabPanes.length > 0) {
          // Measure each tab pane and get the tallest height
          let maxHeight = 0;
          tabPanes.forEach((pane) => {
            const currentHeight = pane.scrollHeight;
            if (currentHeight > maxHeight) maxHeight = currentHeight;
          });
    
          // Set the container height once to the tallest pane
          tabContent.style.height = `${maxHeight}px`;
        }
      }, []);
    


    return (
      <>
        <div className="l-node-frontpage__tabs--outer">
            <div className="l-node-frontpage__tabs">
                <div className="l-node-frontpage__tabs--inner">
                    <ul className="nav nav-tabs" id="searchTabs" role="tablist">
                      {search && (
                        <li className="nav-item" role="presentation">
                            <a className="nav-link active" id="search-tab" data-bs-toggle="tab" data-bs-target="#search" role="tab"><FontAwesomeIcon icon={faSearch} className="fa-fw" /><span>Find a Vehicle</span></a>
                        </li>
                      )}
                      {sell && (
                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="partex-tab" data-bs-toggle="tab" data-bs-target="#partex" role="tab"><FontAwesomeIcon icon={faCar} className="fa-fw" /><span>Sell Your Vehicle</span></a>
                        </li>
                      )}
                      {service && (
                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="service-tab" data-bs-toggle="tab" data-bs-target="#service" role="tab"><FontAwesomeIcon icon={faCalendarAlt} className="fa-fw" /><span>Book a Service</span></a>
                        </li>
                      )}
                    </ul>

                    <div className="tab-content" id="searchTabsContent">
                      {search && (
                        <div className="tab-pane fade show active" id="search" role="tabpanel"><Search /></div>
                      )}
                      {sell && (
                        <div className="tab-pane fade" id="partex" role="tabpanel">
                          <div className="sell-your-car">
                          <p><strong>Sell your vehicle for what it's really worth</strong><br />
                              Start by entering your registration to receive your vehicle valuation</p>
                          <a data-open="partExchange"><button>Sell My Vehicle</button></a>
                          </div>
                        </div>
                      )}
                      {service && (
                        <div className="tab-pane fade" id="service" role="tabpanel">
                          <ServiceBookingForm />
                        </div>
                      )}
                    </div>

                   
                </div>
      
            </div>
        </div>
      </>
    );
  }
  